import styled from '@emotion/styled';
import { useState } from 'react';

import { useApplicantContext } from '@/components/providers/ApplicantContextProvider';
import { useApplicantDueDiligenceQuery } from '@/components/shared/api/queries/applicant';
import { Dialog } from '@/components/shared/components/Dialog';

import { DDDBlockBody } from '../DueDiligence';

const AU10TIX_VENDOR = 'au10tix';

const LinkButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary.actionDefault};
    text-decoration: underline;
    white-space: nowrap;
    flex-shrink: 0;
`;

interface Au10tixDddLinkProps {
    fileId: string;
}

// Matches on the block's source file, since an owner with two IDs has two Au10tix blocks.
export const Au10tixDddLink = ({ fileId }: Au10tixDddLinkProps) => {
    const { applicantId } = useApplicantContext();
    const { data: dueDiligenceGroups } = useApplicantDueDiligenceQuery({
        applicantId: applicantId ?? '',
    });
    const [isOpen, setIsOpen] = useState(false);

    const block = dueDiligenceGroups?.find(
        (item) => item.vendor?.toLowerCase() === AU10TIX_VENDOR && item.fileId === fileId,
    );

    if (!block) {
        return null;
    }

    return (
        <>
            <LinkButton
                type="button"
                onClick={() => setIsOpen(true)}
                data-testid={`view-au10tix-ddd-${fileId}`}
            >
                View Au10tix DDD
            </LinkButton>
            <Dialog
                visible={isOpen}
                onHide={() => setIsOpen(false)}
                header={block.title}
                style={{ width: 'min(700px, 95vw)' }}
                data-testid={`au10tix-ddd-dialog-${fileId}`}
            >
                <DDDBlockBody item={block} />
            </Dialog>
        </>
    );
};
